(() => {
  if (window.internalVideoLazyloadInitialized) return;

  window.internalVideoLazyloadInitialized = true;

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const playButton = event.target.closest('.internal-video__play');
      const player = playButton?.closest('internal-video[data-defer-sources="true"]');
      if (!player) return;

      // Shrine's existing click handler loads and plays the video after this capture handler runs.
      player.querySelectorAll('video source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
    },
    true
  );
})();
